import { RouteConfig, Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import { ALL_ROLES } from '@/utils/permission';

const reportRoutes: RouteConfig = {
  path: '/report',
  component: Layout,
  redirect: '/report/search',
  meta: {
    title: 'Report',
    icon: 'mdi-file-chart',
    alwaysShow: true,
  },
  children: [
    {
      path: 'search',
      component: () =>
        import(
          /* webpackChunkName: "report" */ '@/views/report/search/index.vue'
        ),
      name: 'report-search',
      meta: {
        title: 'Report search',
        icon: 'mdi-file-search',
      },
      children: [
        {
          path: 'result',
          component: () =>
            import(
              /* webpackChunkName: "report" */ '@/views/report/search/result/index.vue'
            ),
          name: 'report-search-result',
          meta: {
            title: 'Report search result',
            icon: 'mdi-file-chart',
            hidden: true,
            noCache: true,
          },
          props: (route: Route) => ({
            ...route.query,
          }),
        },
      ],
    },
  ],
};

export default reportRoutes;
